export const CONTRACT_IQ_CONTRACTS_AND_BILLING_REASON_CODE = '14';
export const MISSING_AGREEMENT_FIELD = 'Missing Agreement';
